<template>
    <SmuMenuDropdown v-model="locale" :items="languageKeys">
        <template #value>{{ locale.toUpperCase() }}</template>
        <template #item="{ item }">
            <div class="w-full" @click="locale = item">
                {{ languages[item] }}
            </div>
        </template>
    </SmuMenuDropdown>
</template>

<script setup lang="ts">
import type { Language } from "~/lib/api/types/verify";

const { locale } = storeToRefs(useLocalSettingsStore());
const { t } = useI18n();

const { data } = storeToRefs(useUserStore());

const fallbackLanguageCodes = [
    "de",
    "en",
    "nl",
    "fr",
    "ar",
    "sv",
    "pl",
    "tr",
    "es",
    "ko",
    "ja",
    "it",
    "cs",
    "da",
    "sk",
    "hu",
];

const languages = computed(() => {
    if (data.value?.master.locales.length) {
        return data.value.master.locales.reduce(
            (accumulator, language: Language) => ({
                ...accumulator,
                [language.code]: language.name[language.code]!,
            }),
            {} as Record<string, string>,
        );
    }

    return Object.fromEntries(
        fallbackLanguageCodes.map((code) => [
            code,
            t(`helpers.language.${code}`),
        ]),
    );
});

const languageKeys = computed(() => Object.keys(languages.value));
</script>
